export var BOTPRESS_NOTIFICATION_POSITION_BOTTOM_RIGHT = 'bottom-right';
export var BOTPRESS_NOTIFICATION_POSITION_BOTTOM_CENTER = 'bottom-center';
export var BOTPRESS_NOTIFICATION_POSITION_BOTTOM_LEFT = 'bottom-left';
export var BOTPRESS_NOTIFICATION_POSITION_TOP_RIGHT = 'top-right';
export var BOTPRESS_NOTIFICATION_POSITION_TOP_CENTER = 'top-center';
export var BOTPRESS_NOTIFICATION_POSITION_TOP_LEFT = 'top-left';
export var BOTPRESS_NOTIFICATION_POSITIONS = [BOTPRESS_NOTIFICATION_POSITION_TOP_RIGHT, BOTPRESS_NOTIFICATION_POSITION_TOP_CENTER, BOTPRESS_NOTIFICATION_POSITION_TOP_LEFT, BOTPRESS_NOTIFICATION_POSITION_BOTTOM_RIGHT, BOTPRESS_NOTIFICATION_POSITION_BOTTOM_CENTER, BOTPRESS_NOTIFICATION_POSITION_BOTTOM_LEFT];
export var BOTPRESS_NOTIFICATION_THEME_LIGHT = 'light';
export var BOTPRESS_NOTIFICATION_THEME_DARK = 'dark';
export var BOTPRESS_NOTIFICATION_THEME_COLORED = 'colored';
export var BOTPRESS_NOTIFICATION_THEMES = [BOTPRESS_NOTIFICATION_THEME_LIGHT, BOTPRESS_NOTIFICATION_THEME_DARK, BOTPRESS_NOTIFICATION_THEME_COLORED];
export var BOTPRESS_NOTIFICATION_DEFAULT_PROPS = {
  autoClose: false,
  position: BOTPRESS_NOTIFICATION_POSITION_BOTTOM_RIGHT,
  theme: BOTPRESS_NOTIFICATION_THEME_LIGHT
};